export default "__VITE_ASSET__C7Q43f1f__"